import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Theme store — single enterprise theme.
 * Custom colors preserved for white-label support.
 */

export interface CustomColorOverrides {
  customPrimary?: string
  customSecondary?: string
  customAccent?: string
  customNeutral?: string
  customBackground?: string
  customText?: string
}

interface ThemeState {
  customColors: CustomColorOverrides
  motionPreference: 'full' | 'reduced' | 'none'
}

interface ThemeActions {
  setCustomColors: (colors: CustomColorOverrides) => void
  updateCustomColor: (key: keyof CustomColorOverrides, value: string) => void
  resetCustomColors: () => void
}

type ThemeStore = ThemeState & ThemeActions

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      customColors: {},
      motionPreference: 'full' as const,

      setCustomColors: (colors: CustomColorOverrides) => {
        set({ customColors: colors })
      },
      updateCustomColor: (key: keyof CustomColorOverrides, value: string) => {
        set((state) => ({
          customColors: { ...state.customColors, [key]: value },
        }))
      },
      resetCustomColors: () => {
        set({ customColors: {} })
      },
    }),
    {
      name: 'ignis-theme-storage',
      partialize: (state) => ({
        customColors: state.customColors,
      }),
      skipHydration: false,
    }
  )
)
